import { render, staticRenderFns } from "./Libraires.vue?vue&type=template&id=dbc0b9a8&scoped=true&"
import script from "./Libraires.vue?vue&type=script&lang=js&"
export * from "./Libraires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc0b9a8",
  null
  
)

export default component.exports